import {NewForm} from '@eitje/form'
import {Input} from '@eitje/web_components'
import {useLocation, useNavigate} from 'react-router'
import {FormSubmitButton, Layout, PageLayout, Title} from '~/components'
import {validateEmail} from '~/helpers'
import {authService} from '~/initializers/auth'

export const Login = () => {
	const navigate = useNavigate()
	const {state} = useLocation()

	const handleLogin = async ({email, password}) => {
		const {token} = await authService.login(email, password)
		if (token) {
			navigate('/', {replace: true}) // replace login page with home page, ensures a valid page in history. Also allows correct behaviour of goBack on direct url navigation to modals.
			if (state?.path) {
				navigate(state.path)
			}
		}
	}

	return (
		<PageLayout gap={8}>
			<Layout margin="25vh 0 0 0">
				<NewForm onSubmit={handleLogin} variant="box" gap={20}>
					<LoginFormContent />
				</NewForm>
			</Layout>
		</PageLayout>
	)
}

const LoginFormContent = () => {
	return (
		<>
			<Title t="auth.welcome" />

			<Layout direction="vertical" width={340} gap={8}>
				<Input field="email" required validate={validateEmail} />
				<Input field="password" secure required />
			</Layout>
			<FormSubmitButton iconLeft={undefined} t="auth.login" />
		</>
	)
}
